import React from 'react';
import { Collapse } from 'react-bootstrap';

import CareMapprTextField from '../../../../../components/Inputs/textField/CareMapprTextField';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import CareMapprDatePicker from '../../../../../components/DatePicker/CareMapprDatePicker';
import { useForm } from 'react-hook-form';
import moment from 'moment';

export const EditAppointmentForm = ({
  open,
  onClose,
  onSave,
  values,
}: {
  open: boolean;
  onClose: () => void;
  onSave: (values: any) => void;
  values: any;
}) => {
  const { register, getValues, watch, setValue, reset } = useForm({
    defaultValues: {
      apptDate: values.apptDate ? moment(values.apptDate).toDate() : '',
      apptTime: values.apptTime
        ? moment(values.apptTime, 'hh:mm A').toDate()
        : '',
      apptType: values.apptType,
    },
  });
  const apptDate = watch('apptDate');
  const apptTime = watch('apptTime');
  const apptType = watch('apptType');
  const onClickSubmit = () => {
    const values = getValues();
    onSave(values);
    reset();
  };
  const onClickClose = () => {
    onClose();
    reset();
  };
  return (
    <Collapse in={open}>
      <div className="px-2">
        <span className="my-2 medication-profile-font-gray row-action-font">
          Edit follow up appointment
        </span>
        <div className="my-3 font-sm">
          <div className="row">
            <div className="col-9">
              <div className="d-flex gap-2">
                <CareMapprTextField
                  label="Appointment type"
                  placeholder="e.g. GP, specialist etc"
                  {...register('apptType')}
                  value={apptType}
                  onChange={(event) => {
                    setValue('apptType', event.target.value);
                  }}
                />
                {/* @ts-expect-error */}
                <CareMapprDatePicker
                  label="Date of appointment"
                  className="mb-0"
                  selectedDate={apptDate}
                  {...register('apptDate')}
                  controlId="apptDate"
                  // @ts-expect-error
                  onChange={(value) => {
                    setValue('apptDate', value);
                  }}
                />
                {/* @ts-expect-error */}
                <CareMapprDatePicker
                  label="Time of appointment"
                  className="mb-0"
                  mode="time"
                  selectedDate={apptTime}
                  {...register('apptTime')}
                  // @ts-expect-error
                  onChange={(value) => {
                    setValue('apptTime', value);
                  }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex gap-2">
                <CareMapprButton
                  variant="transparent"
                  label="Cancel & close"
                  labelClassName="medication-cancel-button"
                  onClick={onClickClose}
                />
                <CareMapprButton label="Save" onClick={onClickSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Collapse>
  );
};
